import Page from "../common/page";
import MotionKvVideo from "../lib/motion-kv-video";
import MotionScrollBox from "../lib/motion-scroll-box";
import {CustomEventHandler} from "../utils/CustomEventHandler";
import Address from "../common/address";
import {isIe11, isMobile, scrollSetting} from "../common/globalVars";
import MotionScrollProduct from "../lib/motion-scroll-product";
import MotionStickyResize from "../lib/motion-sticky-resize";

export default class PagePrestige extends Page {
   setPage() {
      this.posBoxEl = this.el.querySelector('.sec-1 .pos-box');
      new MotionStickyResize(
          this.el.querySelector('.sec-1'),
          this.el.querySelector('.sec-3')
      )

      new MotionKvVideo(
          this.el.querySelector('.sec-1'),
          this.el.querySelector('.sec-1 .line-1'),
          0,0, 0
      );
      new MotionKvVideo(
          this.el.querySelector('.sec-1'),
          this.el.querySelector('.sec-1 .video-1'),
          30,0, 0.6
      );
      new MotionKvVideo(
          this.el.querySelector('.sec-1'),
          this.el.querySelector('.sec-1 .video-2'),
          0,40, 0.6
      );

      if (isIe11()) {
         this.el.querySelector('.sec-1 .video-3').style.display = 'none';
      } else {
         new MotionKvVideo(
             this.el.querySelector('.sec-1'),
             this.el.querySelector('.sec-1 .video-3'),
             100,0, 0, true
         );
      }

      new MotionScrollBox(
          this.el.querySelector('.sec-1'),
          this.el.querySelector('.sec-1 .pos-box'),
          0.8
      );

      // new MotionScrollProduct(
      //     this.el.querySelector('.sec-2 .component-scroll-holder')
      // );

      document.querySelectorAll('.section-title .prestige-navigation-holder a').forEach((el)=> {
         CustomEventHandler.addHandler(el, 'click', (e)=>this.onTitleNavigationClickHandler(e));
      })

      this.el.querySelector('.sec-1 .col-page-title').style.position = 'relative';
      this.el.querySelector('.sec-1 .col-page-title').style.top = `0`;

      if (!scrollSetting.smooth) {
         this.setSticky();
      }

      this.onResizeHandler();
      CustomEventHandler.addHandler(window, 'resize', ()=>this.onResizeHandler());
   }

   onTitleNavigationClickHandler(e) {
      let y = new Address().scrollControl.getHashScrollY(e.target.getAttribute('href'));
      window.scrollTo(0,y);
   }

   setSticky() {
      this.stickyEl = this.el.querySelector('.sticky-holder');
      this.stickyEl.style.position = 'sticky';
      this.stickyEl.parentNode.style.height = '100%';

      this.posBoxEl.style.position = 'sticky';
   }

   onResizeHandler() {
      if (!scrollSetting.smooth) {
         this.posBoxEl.style.top = `${window.innerHeight / 2 - parseFloat(window.getComputedStyle(this.posBoxEl).height) / 2}px`;
      }
      this.el.querySelector('.sec-1 .page-title').style.paddingBottom = `${window.innerHeight/10}px`;
   }
}
